import createEmotionCache from '@emotion/cache'

// One definition for BOTH sides: the server (per-request, style extraction) and the
// client (hydration) must create the cache with the same options — the key is how
// hydration claims the server-rendered style tags, and `prepend` keeps MUI styles
// overridable by app styles.
export const createAppEmotionCache = () =>
  createEmotionCache({ key: 'css', prepend: true })
